module.exports = __webpack_public_path__ + "img/settings.9b91be55.svg";